import Vant from 'vant'
import 'vant/lib/index.css'

export default function (App) {
  App.use(Vant)
}
